import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";

export const getWabaId = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop-whatsapp-account?domain=${domain}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}